import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { graphql, gql, compose } from 'react-apollo';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './BlogHomepage.css';

// Component
import BlogHomepageListings from '../../components/BlogHomepageListings';

class BlogHomepage extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    const { title, description, getBlogHomepageQuery } = this.props;

    return (
      <div className={cx(s.root, 'searchPage', 'searchResultScrollBar')}>
        <div className={s.container}>
          <h1>{title}</h1>
          <h2>{description}</h2>
          <div className={cx(s.searchResultContainer, s.listItemOnly)}>
            <BlogHomepageListings
              getBlogHomepageQuery={getBlogHomepageQuery}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(gql`
  query getBlogHomepage ($currentPage: Int) {
    getBlogHomepage(currentPage: $currentPage) {
      blogPosts {
        id
        metaTitle
        metaDescription
        pageUrl
        pageTitle
        isEnable
        createdAt
        coverPhoto
        coverPhotoName
      }
      count
    }
  }`, {
    name: 'getBlogHomepageQuery',
    options: {
      variables: {
        currentPage: 1
      },
      ssr: false,
      fetchPolicy: 'network-only'
    }
  })
)(BlogHomepage);



// WEBPACK FOOTER //
// src/routes/blogHomepage/BlogHomepage.js